<template>
    <button class="cursor-pointer disabled:cursor-not-allowed disabled:opacity-50">
        <slot />
    </button>
</template>
